import React from 'react';
import { Dimmer } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/modules/dimmer.less';

export default Dimmer;
